export function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M4.44323 9.36069C4.01955 9.36069 3.67441 9.01554 3.67441 8.59187V5.92383H1.00637C0.582696 5.922 0.237549 5.57868 0.237549 5.15501V4.21818C0.237549 3.79451 0.582696 3.44937 1.00637 3.44937H3.67623V0.7795C3.67623 0.355828 4.02138 0.0106812 4.44505 0.0106812H5.38188C5.80555 0.0106812 6.1507 0.355828 6.1507 0.7795V3.44937H8.81874C9.24241 3.44937 9.58756 3.79451 9.58756 4.21818V5.15501C9.58756 5.57868 9.24241 5.92383 8.81874 5.92383H6.1507V8.59187C6.1507 9.01554 5.80555 9.36069 5.38188 9.36069H4.44323Z"
        fill="#1B1B1B"
      />
      <path
        d="M8.81874 3.63034H5.96808V0.779683C5.96808 0.45645 5.70511 0.193481 5.38188 0.193481H4.44505C4.12182 0.193481 3.85885 0.45645 3.85885 0.779683V3.63217H1.00637C0.683135 3.63217 0.420166 3.89513 0.420166 4.21837V5.15519C0.420166 5.47843 0.683135 5.7414 1.00637 5.7414H3.85885V8.59205C3.85885 8.91529 4.12182 9.17825 4.44505 9.17825H5.38188C5.70511 9.17825 5.96808 8.91529 5.96808 8.59205V5.7414H8.81874C9.14197 5.7414 9.40494 5.47843 9.40494 5.15519V4.21837C9.40494 3.89331 9.14197 3.63034 8.81874 3.63034Z"
        fill="#D9D7C5"
      />
    </svg>
  )
}
